import { FileChooser } from '@apply/components';
import { ShowIf } from '@apply/ui'; //TODO: ShowIf should be moved to components - update after
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';

export const CompanyLogoFileUpload: React.FC = () => {
    const logoUrl = useBrokerDetailsStore((s) => s.companyLogoUrl);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);

    return (
        <>
            <label htmlFor='companyLogoFile'>Company Logo:</label>
            <br />
            <ShowIf showIf={logoUrl}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img
                        src={logoUrl}
                        alt='Your company logo.'
                        style={{ maxWidth: '300px', maxHeight: '300px', objectFit: 'contain', paddingTop: '10px' }}
                    />
                </div>
            </ShowIf>
            <ShowIf showIf={!logoUrl}>
                <FileChooser
                    id={'companyLogoChooser'}
                    dataTestid={'companyLogoChooser'}
                    handleChange={(e) => updateFields({ companyLogoFile: e.target.files?.[0] })}
                    labeledBy={'companyLogoFile'}
                    acceptableFileTypes='image/jpeg, image/png, image/gif'
                />
                <p style={{ fontSize: '0.7rem' }}>
                    Max resolution: <strong>512×512 px</strong>
                    <br />
                    Max file size: <strong>2 MB</strong>
                    <br />
                    You can upload <strong>JPEG</strong>, <strong>PNG</strong>, or <strong>GIF</strong> images.
                </p>
            </ShowIf>
        </>
    );
};
